import { QueryParams } from 'types/enums';

/**
 * Get the current query string with a particular query excluded from the query string
 *
 * Example: '?page=1&tab=Samples' could have the `tab` query stripped out to return '?page=1'
 */
export function getPartOfCurrentQueryString({
    routerQueryString,
    queriesToExclude,
}: {
    routerQueryString: string;
    queriesToExclude: string | string[];
}): string {
    const params = new URLSearchParams(routerQueryString);
    const newParams = new URLSearchParams();

    for (const [name, value] of params) {
        newParams.append(name.toLowerCase(), value);
    }

    if (Array.isArray(queriesToExclude)) {
        queriesToExclude.forEach((query) => newParams.delete(query));
    } else {
        newParams.delete(queriesToExclude);
    }

    return newParams.toString();
}

export function getParamFromQueryString(
    routerQueryString: string,
    paramsToGet: QueryParams,
): string | null {
    const params = new URLSearchParams(routerQueryString);

    return params.get(paramsToGet);
}
